import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';

@Injectable({
    providedIn: 'root'
})
export class GermplasmDetailsPopupService {

    private modal: Modal | null = null;

    constructor(private router: Router) {
    }

    open(gid: any, initialTab: string = 'germplasm-basic-details', hasChanges: boolean = false) {
        // Navigate to the modal route with initial tab
        this.router.navigate([{
            outlets: {
                'germplasmDetailsPopup': ['germplasm-details-main', gid,  { initialTab: initialTab, hasChanges: hasChanges }]
            }
        }], { onSameUrlNavigation: 'reload', queryParamsHandling: 'preserve' }).then(() => {
            // Initialize and show Bootstrap modal
            const modalElement = document.getElementById('routerModal');
            if (modalElement) {
                // Set z-index before initializing the modal
                modalElement.style.zIndex = '10100'; // or any other value you need
                const backdropElement = document.querySelector('.modal-backdrop');
                if (backdropElement) {
                    (backdropElement as HTMLElement).style.zIndex = '10000';
                }

                this.modal = new Modal(modalElement, {
                    keyboard: true,
                    backdrop: 'static',  // Prevent closing by clicking outside
                });
                this.modal.show();

                // Handle modal closing
                modalElement.addEventListener('hidden.bs.modal', () => {
                    this.router.navigate([{ outlets: { germplasmDetailsPopup: null, modalContent: null } }], { queryParamsHandling: 'preserve' });
                    // Reset the backdrop zindex
                    const backdropElement = document.querySelector('.modal-backdrop');
                    if (backdropElement) {
                        (backdropElement as HTMLElement).style.zIndex = '';
                    }
                });
            }
        });
    }

    close() {
        if (this.modal) {
            this.modal.hide();
        }
    }

    resetPopup() {
        return this.router.navigate([{ outlets: { germplasmDetailsPopup: null, modalContent: null } }], { queryParamsHandling: 'preserve' });
    }
}
